module.exports = __webpack_public_path__ + "static/media/ebner.fb8b4728.jpg";